<div class="row">
  <div class="col-md-8">
    <h4 class="title">Credit Card</h4>
    <!-- <div class="search-hero">
      <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;" [(ngModel)]="searchQR"
        autocomplete="off" placeholder="&#xf002; Search...">
    </div> -->
  </div>
  <div class="col-md-4 text-right" style="margin-bottom: 10px;">
    <button type="button" class="btn btn-primary mr-0" (click)="client_form()"><i class="fa fa-plus"
        aria-hidden="true"></i> Add</button>
  </div>
</div>

<div class="row" style="margin-bottom: 10px;">
  <div class="col-md-3">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input type="text" pInputText placeholder="Account Search" />
    </span>
  </div>
  <div class="col-md-3">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input type="text" pInputText placeholder="Full Search" />
    </span>
  </div>
  <div class="col-md-6 text-right">
    <button class="btn btn-primary" style="margin-right: 10px;">Personal Loan</button>

    <button class="btn btn-primary" style="margin-right: 10px;">Auto Loan</button>

    <button class="btn btn-primary" style="margin-right: 10px;">Credit Cards</button>

    <button class="btn btn-primary" style="margin-right: 0px;">Sales Finance</button>
  </div>
</div>
<div class="doc-table">

  <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="50"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

    <ng-template pTemplate="header">

      <tr style="text-align: center;" class="thhead">
        <th style="width: 50px;">S.No</th>
        <th>Account No</th>
        <th>Customer No</th>
        <th>Name</th>
        <th>Portfolio</th>
        <th>Bucket:</th>
        <th>OS Amount:</th>
        <th>OD Amount:</th>
        <th>Phone Number</th>
        <th style="width: 100px;">Action</th>


    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
      <tr class="tdrow">
        <td style="text-align: center;">{{i+1}}</td>
        <td><a (click)="showPositionDialog()" style="color: #0e69dd;">1.26472587459</a></td>
        <td>Lorem ipsum.</td>
        <td>Lorem ipsum.</td>
        <td>Lorem ipsum.</td>
        <td>Lorem ipsum.</td>
        <td>Lorem ipsum.</td>
        <td>Lorem ipsum.</td>
        <td>Lorem ipsum.</td>
        <!-- <td>
                User
            </td>
            <td>
                Admin
            </td>
            <td>
                16-09-2020
            </td>
            <td>
                17-09-2020
            </td> -->
        <td class="act">
          <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
          <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
          <!-- <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="profile()" pTooltip="Profile"></i> -->
        </td>
      </tr>
    </ng-template>
   </p-table>  </div>

</div>

<p-dialog header="Account Details" [(visible)]="displayPosition" position="center" [modal]="true"
  [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div class="">
    <div class="row pr-hd">
      <div class="col-md-2 col-xs-12 col-sm-6 col-lg-2 pr-img">
        <img src="https://www.svgimages.com/svg-image/s5/man-passportsize-silhouette-icon-256x256.png" alt="stack photo"
          class="img">
      </div>
      <div class="col-md-10 col-xs-12 col-sm-6 col-lg-10">
        <h2 style="font-size: 12px;margin-bottom: 0px;line-height: 20px;">John Doe</h2>
        <p style="font-size: 12px;color: #d0d0d0">Acc.No: 1.26472587459</p>
        <a class="pr-v" style="margin-right: 0px;" (click)="cus360()">View 360&#176;</a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <table class="pr-det" style="padding-left: 20px;">
          <tr>
            <th>Ageing:</th>
            <td>731+</td>
          </tr>
          <tr>
            <th>Email:</th>
            <td>test@gmail.com</td>
          </tr>
          <tr>
            <th>Gender:</th>
            <td>test@gmail.com</td>
          </tr>
          <tr>
            <th>Nationality:</th>
            <td>Sri Lanka</td>
          </tr>

        </table>
      </div>
      <div class="col-md-6">
        <table class="pr-det" style="padding-left: 20px;">
          <tr>
            <th>ID type:</th>
            <td>Emirates ID</td>
          </tr>
          <tr>
            <th>ID No:</th>
            <td>7841xxx408479</td>
          </tr>
          <tr>
            <th>Status:</th>
            <td>INACTIVE</td>
          </tr>
          <!-- <tr>
            <th>Branch:</th>
            <td>Mizher Mall</td>
          </tr>
          <tr>
            <th>Branch Code:</th>
            <td>1244</td>
          </tr>
          <tr>
            <th>Sub Products:</th>
            <td>NA</td>
          </tr>
          <tr>
            <th>CIF Number:</th>
            <td>NA</td>
          </tr>
          <tr>
            <th>PTP Status:</th>
            <td>NA</td>
          </tr> -->
          <tr>
            <th>Overdue Amount:</th>
            <td>25,00000</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</p-dialog>
